import { State } from ".";

export const getCurrentDay = (state: State): string => state.ui.currentDay;
